import type { ImageModel } from '@rocco/types/image-model';
import { Image } from '@rocco/components/image';
import { cn } from '@rocco/utils/cn';

interface ProfessionalTileLogoProps {
    image: ImageModel;
    background: string | null;
    /** Render a smaller logo (for compact tile contexts like recently viewed). */
    compact?: boolean;
}

export const ProfessionalTileLogo = (props: ProfessionalTileLogoProps) => {
    const { image, background, compact = false } = props;

    return (
        <div
            className={cn(
                'flex items-center justify-center overflow-hidden rounded-full p-0.5',
                compact ? 'size-14' : 'size-22',
            )}
            style={{
                backgroundColor: background || 'white',
            }}
        >
            <Image
                src={image.src}
                alt={image.alt ?? 'Logo'}
                size="professionalLogo"
            />
        </div>
    );
};
